import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
export default function useTexts() {
  const { t } = useTranslation(
    TranslationsKeys.MANAGEMENT_TOOLS_CLASSROOMS_FORM,
  );

  return {
    form: {
      title: t(`create.title`),
      create: t(`create.create`),
      cancel: t(`create.cancel`),
      createSuccess: t(`create.createSuccess`),
      updateSuccess: t(`create.updateSuccess`),
      error: t(`create.error`),
      conflictError: t(`create.conflictError`),
      type: t(`create.type`),
      code: t(`create.code`),
      name: t(`create.name`),
      capacity: t(`create.capacity`),
      campus: t(`create.campus`),
      description: t(`create.description`),
      state: t(`create.state`),
      status: {
        active: t(`create.status.active`),
        inactive: t(`create.status.inactive`),
      },
    },
    edit: {
      title: t(`edit.title`),
    },
    delete: {
      title: t(`delete.title`),
      noEvents: t(`delete.noEvents`),
      cannotDelete: t(`delete.cannotDelete`),
      cannotSubtitle: t(`delete.cannotSubtitle`),
      hasPastEvents: t(`delete.hasPastEvents`),
      hasPastEventsSubtitle: t(`delete.hasPastEventsSubtitle`),
      success: t(`delete.success`),
      buttons: {
        cancel: t(`delete.buttons.cancel`),
        delete: t(`delete.buttons.delete`),
        ok: t(`delete.buttons.ok`),
      },
    },
    disable: {
      title: t(`disable.title`),
      subtitle: t(`disable.subtitle`),
      cannotDisable: t(`disable.cannotDisable`),
      cannotDisableSubtitle: t(`disable.cannotDisableSubtitle`),
      success: t(`disable.success`),
      buttons: {
        cancel: t(`disable.buttons.cancel`),
        disable: t(`disable.buttons.disable`),
      },
    },
    enable: {
      success: t(`enable.success`),
    },
    reservationDetails: {
      subject: t(`reservationDetails.subject`),
      section: t(`reservationDetails.section`),
      startDate: t(`reservationDetails.startDate`),
      endDate: t(`reservationDetails.endDate`),
      schedule: t(`reservationDetails.schedule`),
      event: t(`reservationDetails.event`),
    },
  };
}
